import React from "react";
import { Sun, Moon, Menu } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

const navLinks = [
  { name: "Home", href: "/#home" },
  { name: "About", href: "/#about" },
  { name: "Services", href: "/#services" },
  { name: "Portfolio", href: "/#portfolio" },
];

export default function Header({ dark, setDark, menuOpen, setMenuOpen }) {
  const logoSrc = dark ? "/TechADR-Logo-White.svg" : "/TechADR-Logo.svg";
  return (
    <header className="sticky top-0 z-40 w-full bg-white/60 dark:bg-[#1b1c4e]/80 backdrop-blur border-b border-[#e6e9f5] dark:border-[#23244d] shadow-lg transition-all">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 py-2">
        <div className="flex items-center gap-3">
          <Link to="/#home" style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
            <img src={logoSrc} alt="Tech ADR Logo" className="h-10 w-auto" />
            <span className="font-bold text-xl tracking-tight text-[#1b1c4e] dark:text-white">Tech ADR</span>
          </Link>
        </div>
        <nav className="hidden md:flex gap-6">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="font-medium text-[#1b1c4e] dark:text-white hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
            >
              {link.name}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <button
            aria-label="Toggle dark mode"
            onClick={() => setDark((d) => !d)}
            className="p-2 rounded-full hover:bg-indigo-100 dark:hover:bg-[#23244d] transition"
          >
            {dark ? <Sun className="w-5 h-5 text-yellow-400" /> : <Moon className="w-5 h-5 text-[#1b1c4e]" />}
          </button>
          <a href="#contact" className="hidden md:inline-block px-5 py-2 rounded-lg bg-[#1b1c4e] text-white font-semibold shadow hover:bg-indigo-700 transition text-base ml-2">Contact</a>
          <button
            className="md:hidden p-2 rounded hover:bg-indigo-100 dark:hover:bg-[#23244d]"
            onClick={() => setMenuOpen((m) => !m)}
            aria-label="Open menu"
          >
            <Menu className="w-6 h-6 text-[#1b1c4e] dark:text-white" />
          </button>
        </div>
      </div>
      {/* Mobile Nav */}
      <AnimatePresence>
        {menuOpen && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden bg-white dark:bg-[#1b1c4e] px-4 py-2 border-t border-[#e6e9f5] dark:border-[#23244d]"
          >
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="font-medium text-[#1b1c4e] dark:text-white hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                  onClick={() => setMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <a href="#contact" className="inline-block px-5 py-2 rounded-lg bg-[#1b1c4e] text-white font-semibold shadow hover:bg-indigo-700 transition text-base mt-2">Contact</a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
} 